import addFirstCignaRef from 'sites/enroll.pivothealth.com/welcome-back-quote/addFirstCignaRef'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import forEach from 'utils/DOM/forEach'
import getById from 'utils/DOM/getById'
import getURLParams from 'utils/DOM/getURLParams'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import renderFilters from './renderFilters'
import renderPlanFilters from './renderPlanFilters'
import getTemplate from './utils/getTemplate'
import { renderMultiCarrierPlans, renderPlans } from './utils/renderPlans'
import renderRecommended from './utils/renderRecommended'
import renderRecommendedLink from './utils/renderRecommendedLink'
import getMultiCarrierCoverageDetails from 'utils/pivot/multicarrier/get-multicarrier-coverage-details'
import renderAdditionalProducts from './components/additional-products/render'
import { propAccessor } from '@hc-frontend/utils'
import { enableMultiCarrierPlans } from 'utils/experiments'

const templatePlan = getTemplate('template-plan')
const templateMultiCarrierPlan = getTemplate('template-multi-carrier-plan')
const plansWrap = getById('plans-wrap')
const tileWrap = getById('tiles-wrap')
const tiles = getById('tiles')

const getMultiCarrierPlans = state =>
  Object.entries(state.plans)
    .map(entry => entry[1])
    .filter((plan: Plan) => plan?.multiCarrierPlan)

const renderStandAloneTabContent = state => {
  let hiddenFilters
  if (state.hcStorage.location.state_acronym === 'ND') {
    hiddenFilters = { period: [360] }
  }
  renderFilters(
    state.filterOptions,
    state.filters,
    state.defaultPeriod,
    state,
    hiddenFilters
  )

  renderPlans(plansWrap, templatePlan, state, state.plansToShow)
  renderPlanFilters(
    state.plansToShow,
    state.plans,
    state.filterOptionsByProductType,
    state.filtersByProductType,
    state
  )

  const showRecommended = state.recommended.length > 0
  if (showRecommended) {
    renderRecommended(tileWrap, state.templateTile, state, state.recommended, true)

    if (state.recommendDurations) {
      renderRecommendedLink(state.recommendDurations)
    }
  } else {
    tileWrap.innerHTML = ''
  }

  toggleClass(tiles, 'd-none', !showRecommended)

  forEach('.js-option-card', node => {
    toggleClass(node, 'Card-active', state.filters.type.includes(node.dataset.id))
  })

  addFirstCignaRef()

  updateAddons(state)
}

const renderMultiCarrierTabContent = state => {
  const multiCarrierPlans = getMultiCarrierPlans(state)

  const formattedPlans = {}
  multiCarrierPlans.forEach(plan => {
    formattedPlans[plan.planId] = plan
  })

  renderMultiCarrierPlans(plansWrap, templateMultiCarrierPlan, state, multiCarrierPlans)

  const plansToShow = multiCarrierPlans.map(plan => plan.planId)
  const { completeLabel, available } = getMultiCarrierCoverageDetails(state)
  toggleClass('.advise', 'd-none', !available)
  textContent('.complete-lable-coverage', completeLabel)

  renderPlanFilters(
    plansToShow,
    formattedPlans,
    state.filterOptionsByProductType,
    state.filtersByProductType,
    state,
    true
  )
}

const renderAdditionalProductTabContent = async state => {
  toggleClass('#header-content', 'd-none', true)
  toggleClass('#shopping-tip-wrap', 'd-none', true)
  toggleClass('#tiles', 'd-none', true)
  toggleClass('#filters-wrap', 'd-none', true)

  renderAdditionalProducts({
    externalPartners: propAccessor(state, 'hcStorage.externalPartners', [])
  })
}

function updateDOM(state) {
  // If no plans are present, show the "no match" message
  if (state.plansSTM.length === 0) {
    toggleClass(document.body, 'noMatch', true)
    return undefined
  }

  // Read the URL parameters to identify what to render
  const urlParams = getURLParams()
  const isMultiCarrier = urlParams.months !== '4' && urlParams.months
  const isAdditionalProduct = urlParams.tab === 'additional-products'

  // Render Additional Product Tab if applicable
  if (isAdditionalProduct) {
    renderAdditionalProductTabContent(state)
    return
  }

  // If multi-carrier is enabled and the user is on the multi-carrier tab,  attempt to render the multi-carrier plans
  if (enableMultiCarrierPlans() && isMultiCarrier) {
    // Before rendering the multi-carrier plans, check if there are any multi-carrier plans available or render the stand alone plans
    const multiCarrierPlans = getMultiCarrierPlans(state)
    if (multiCarrierPlans.length === 0) {
      textContent('#toolbar-stm-4', 'Short Term')
      toggleClass('#toolbar-stm-multi', 'd-none', true)
      const link = getById('toolbar-stm-4') as HTMLLinkElement
      link && document.location.assign(link.href)
    }

    // If there are multi-carrier plans available, render them
    renderMultiCarrierTabContent(state)
    return
  }

  // Finally render the Stand Alone tab content
  renderStandAloneTabContent(state)
}

export default updateDOM
